// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileStatisticsHeader_wrapper_a7be2"};